var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button--outline",attrs:{"type":"reset"},on:{"click":function($event){return _vm.handleClick()}}},[_vm._t("default",[_vm._v("Reset")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }